export default __webpack_public_path__ + "static/media/Group167.adca36c2.png";